import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react';
import { Gender, IStemAnimal } from 'shared/api/api';

export interface YoungAnimalMoveEvent {
	date?: Date;
	gender?: Gender;
	idNumber?: string;
	transponderNr?: number;
	sectionId?: string;
	penId?: string;
	youngAnimal?: IStemAnimal | undefined;
	feedCurveNumber?: number | undefined;
	fixedDeviation?: number | undefined;
	deviationPeriod?: number | undefined;
	tempFeedDeviation?: number | undefined;
}

interface MoveEventContextType {
	state: YoungAnimalMoveEvent;
	updateField: (field: keyof YoungAnimalMoveEvent, value: any) => void;
	setFullState: (state: YoungAnimalMoveEvent) => void;
}

const MoveEventContext = createContext<MoveEventContextType | undefined>(undefined);

export const YoungAnimalMoveEventProvider = ({
	children,
	initialState,
}: {
	children: ReactNode;
	initialState: YoungAnimalMoveEvent;
}) => {
	const [state, setState] = useState<YoungAnimalMoveEvent>(initialState);

	const updateField = (field: keyof YoungAnimalMoveEvent, value: any) => {
		setState(prev => ({
			...prev,
			[field]: value,
		}));
	};

	const setFullState = (newState: YoungAnimalMoveEvent) => {
		setState(newState);
	};

	const value = useMemo(() => ({ state, updateField, setFullState }), [state]);

	return <MoveEventContext.Provider value={value}>{children}</MoveEventContext.Provider>;
};

export const useYoungAnimalMoveEvent = () => {
	const context = useContext(MoveEventContext);
	if (!context) {
		throw new Error('useMoveEvent must be used within a MoveEventProvider');
	}
	return context;
};
